import * as React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "../../utils/className.js";

export function BottomNavigation({ items, className }) {
  return (
    <nav
      className={cn(
        "fixed bottom-0 left-0 w-full bg-[#fff] border-t border-border z-40",
        className
      )}
    >
      <div className="flex items-center justify-around h-16 px-4">
        {items.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            className={({ isActive }) =>
              cn(
                "flex flex-col items-center justify-center gap-1 p-2 text-xs transition-colors relative rounded-xl min-w-[20%]",
                isActive
                  ? "font-semibold bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white rounded-xl"
                  : "text-muted-foreground hover:text-foreground"
              )
            }
          >
            <div className="relative">
              <item.icon className="w-5 h-5" />
              {item.badge && item.badge > 0 && (
                <span className="absolute flex items-center justify-center w-4 h-4 text-xs rounded-full -top-1 -right-1 bg-destructive text-destructive-foreground">
                  {item.badge > 99 ? "99+" : item.badge}
                </span>
              )}
            </div>
            <span className="leading-none">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
